import React from "react";
import { Link } from "react-router-dom";
import { getImageLink } from "../../../../../services/asset";
import IndexImage from "../../../../IndexImage";
import styles from "./categoryTile.scss";

function CategoryTile({ category, path }) {
  return (
    <Link
      title={category.displayName}
      to={`${path}/${category.name}`}
      className={styles.categoryContainer}
    >
      <IndexImage
        className={styles.categoryImage}
        src={getImageLink(category.iconId)}
        alt={category.displayName}
      />
      <span className={styles.categoryName}>{category.displayName}</span>
    </Link>
  );
}

export default CategoryTile;



// WEBPACK FOOTER //
// ./src/containers/AdFormPage/SelectingCategory/CategorySelect/CategoryTile/index.tsx